import { createFileRoute } from '@tanstack/react-router'
import { TypesSyncRunPage } from '../../../../../components/TypesSyncRunPage'

export const Route = createFileRoute('/$org/types/sync/runs/$runUid')({
  component: TypesSyncRunPage,
})
